export const DEFAULT_MAINTENANCE_IDLE_POLL_MINUTES: number = 5
export const DEFAULT_MAINTENANCE_ACTIVE_POLL_MINUTES: number = 1
export const DEFAULT_MAINTENANCE_REMINDER_FROM_MINUTES: number = 30
export const DEFAULT_MAINTENANCE_MAX_IDLE_POLL_MINUTES: number = 15
export const DEFAULT_MAINTENANCE_MAX_ACTIVE_POLL_MINUTES: number = 5
export const DEFAULT_MAINTENANCE_MAX_REMINDER_FROM_MINUTES: number = 60
